import home from './home.vue'

export default {
	home,
}


// WEBPACK FOOTER //
// ./src/components/homes/index.js